// extracted by mini-css-extract-plugin
export default {"section":"QRPreview_section__eOyba","card":"QRPreview_card__Z7O1a","qrBox":"QRPreview_qrBox__oP9yf","star":"QRPreview_star__JVo7F"};